module.exports = __webpack_public_path__ + "assets/img/bargin-icon.9f2399dc.png";